var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnCloseRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 5108",
    width: 32,
    height: 32,
    rx: 8,
    style: {
      fill: "#e7e9ec"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD569\\uCE58\\uAE30 13",
    d: "M6429.3 2350.7a1.015 1.015 0 0 1 0-1.435l4.268-4.268-4.268-4.268a1.015 1.015 0 0 1 1.435-1.435l4.268 4.268 4.268-4.268a1.015 1.015 0 0 1 1.435 1.435l-4.268 4.268 4.268 4.268a1.015 1.015 0 0 1-1.435 1.435l-4.268-4.268-4.268 4.268a1.015 1.015 0 0 1-1.435 0z",
    transform: "translate(-6419 -2329)",
    style: {
      fill: "#c13537"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCloseRed);
export default __webpack_public_path__ + "static/media/icn_close_red.1688ea5266b75056cd8365cecba4f2d1.svg";
export { ForwardRef as ReactComponent };